import type { Variants } from 'framer-motion';

export const EASE = {
  smooth: [0.6, 0.01, 0.05, 0.95] as const,
  spring: [0.34, 1.56, 0.64, 1] as const,
  elegant: [0.16, 1, 0.3, 1] as const,
  out: [0.22, 1, 0.36, 1] as const,
};

// 블러 효과가 있는 fade in up
export const fadeInUpBlur: Variants = {
  hidden: {
    opacity: 0,
    y: 30,
    filter: 'blur(10px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.8,
      ease: EASE.elegant,
    },
  },
};

// 기본 fade in up (블러 없음)
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: EASE.elegant },
  },
};

// 스케일 + 페이드
export const fadeInScale: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.92,
    filter: 'blur(8px)',
  },
  visible: {
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)',
    transition: {
      duration: 0.7,
      ease: EASE.spring,
    },
  },
};

// 컨테이너용 stagger
export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1,
    },
  },
};

// 빠른 stagger (카드 리스트용)
export const staggerContainerFast: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.05,
    },
  },
};

// stagger 아이템 (블러 포함)
export const staggerItem: Variants = {
  hidden: {
    opacity: 0,
    y: 20,
    filter: 'blur(6px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.5,
      ease: EASE.elegant,
    },
  },
};

// 카드용 stagger 아이템 (스케일 포함)
export const staggerCard: Variants = {
  hidden: {
    opacity: 0,
    y: 30,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: EASE.out,
    },
  },
};

// 바운스 인
export const bounceIn: Variants = {
  hidden: {
    opacity: 0,
    y: 40,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.7,
      ease: EASE.spring,
    },
  },
};

// 로고/아이콘 reveal (커스텀 딜레이)
export const logoReveal: Variants = {
  hidden: {
    opacity: 0,
    scale: 0.7,
    y: 10,
  },
  visible: (i: number) => ({
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.4,
      delay: 0.2 + i * 0.1,
      ease: EASE.spring,
    },
  }),
};

// Hover 효과들
export const hoverScale = {
  scale: 1.02,
  transition: { duration: 0.2, ease: EASE.out },
};

export const hoverLift = {
  y: -4,
  scale: 1.02,
  transition: { duration: 0.25, ease: EASE.out },
};

export const tapScale = {
  scale: 0.98,
};

// 스프링 바운스 (더 드라마틱한 등장)
export const springBounce: Variants = {
  hidden: {
    opacity: 0,
    y: 60,
    scale: 0.85,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 20,
      mass: 1,
    },
  },
};

// 플로팅 애니메이션 (떠다니는 효과)
export const floating = {
  y: [0, -8, 0],
  transition: {
    duration: 3,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};

// 플로팅 + 회전 (더 다이나믹)
export const floatingRotate = {
  y: [0, -6, 0],
  rotate: [-2, 2, -2],
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};

// 펄스 글로우 (CTA 버튼용)
export const pulseGlow = {
  scale: [1, 1.02, 1],
  boxShadow: [
    '0 0 0 0 rgba(228, 48, 44, 0)',
    '0 0 20px 4px rgba(228, 48, 44, 0.4)',
    '0 0 0 0 rgba(228, 48, 44, 0)',
  ],
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: 'easeInOut',
  },
};

// 시선 유도용 셔플 (좌우 흔들림)
export const attentionShake = {
  x: [0, -3, 3, -3, 3, 0],
  transition: {
    duration: 0.5,
    delay: 2,
    repeat: Infinity,
    repeatDelay: 4,
  },
};
